<template lang="pug">
  v-card.mx-2.sdo-card.overflow-auto
    v-card-text(v-html="previewDocument")
</template>
<script>
export default {
  props: {
    previewDocument: { type: String, required: true },
  },
};
</script>
